export const TapPayUpdateStatus = {
  SUCCESS: 0,
  UNKNOWN: 1,
  FAILURE: 2,
} as const

export interface ValidationResult {
  /**
   * @deprecated 使用 card.prime 取代
   */
  prime?: string
  // 使用 Direct Pay 的時候 , methodName 為 card 的時候才會回傳以下資訊
  card?: {
    bank_id: string
    funding: number
    issuer_zh_tw: string
    lastfour: string
    level: string
    prime: string
    type: number
    issuer: string
    bincode: string
    country: string
    countrycode: string
  }
  card_identifier: string
  clientip: string
  merchant_reference_info?: {
    affiliate_codes: string[]
  }
  msg: string
  status: number
}

export type GetPrime = (result: ValidationResult) => void

export interface PaymentRequest {
  supportedNetworks: string[]
  supportedMethods: string[]
  displayItems: {
    label: string
    amount: {
      currency: string
      value: string
    }
  }[]
  total: {
    label: string
    amount: {
      currency: string
      value: unknown
    }
  }
  options?: {
    requestPayerEmail: boolean
    requestPayerName: boolean
    requestPayerPhone: boolean
    requestShipping: boolean
    shippingType: 'shipping'
  }
}

export interface Prime {
  prime: string
  // 加上運費的價格
  total_amount: string
  status: number
  msg: string
  client_ip: string
  payer: {
    name: string
    phone: string
    email: string
  }
  shippingAddress: {
    country: string
    addressLine: unknown
    region: string
    city: string
    dependentLocality: string
    postalCode: string
    sortingCode: string
    languageCode: string
    organization: string
    recipient: string
    phone: string
  }
  shippingOption: string
  methodName: 'card' | 'google_pay' | 'android_pay' | 'apple_pay'
  requestId: string
  card?: ValidationResult['card']
}

export type CardType = 'mastercard' | 'visa' | 'jcb' | 'amex' | 'unionpay' | 'unknown'

export interface CardUpdate {
  canGetPrime: boolean
  cardType: CardType
  hasError: boolean
  status: {
    /** card */
    ccv: number
    expiry: number
    number: number
    /** cardholder */
    name_en: number
    phone_country_code: number
    phone_number: number
    email: number
  }
}

export interface TPDirect {
  setupSDK: (appID: string, appKey: string, env: 'production' | 'sandbox') => void

  linePay: {
    getPrime: (cb: GetPrime) => void
  }

  jkoPay: {
    getPrime: (cb: GetPrime) => void
  }

  card: {
    getPrime: (cb: GetPrime) => void
    setup: (params: unknown) => void
    onUpdate: (cb: (update: CardUpdate) => void) => void
  }

  paymentRequestApi: {
    getPrime: (cb: (prime: Prime) => void) => void
    setupApplePay: (params: { merchantIdentifier?: string, countryCode: string }) => void
    checkAvailability: () => boolean
    setupPaymentRequest: (
      paymentRequest: PaymentRequest,
      callback: (params: {
        browserSupportPaymentRequest: boolean
        canMakePaymentWithActiveCard: boolean
      }) => void)
    => void
  }
}

// Global Window interface augmentation
declare global {
  interface Window {
    TPDirect?: TPDirect
  }
}
